





































import { mapActions } from 'vuex';
import { getConnectors } from '@/api/ConnectorsApi';
import Tile from './Tile';

export default {
  name: 'ConnectorsPage',
  components: {
    Tile,
  },
  data() {
    return {
      loading: false,
      connectors: [],
    };
  },
  async created() {
    this.setPageTitle({ title: 'Connectors', visible: false });
    this.fetchConnectors();
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
    }),
    fetchConnectors() {
      this.loading = true;
      getConnectors().then(connectors => {
        this.connectors = connectors.sort((a, b) => a.name.localeCompare(b.name));
        this.loading = false;
      });
    },
  },
};
